import { AppDispatch, AppThunk } from '../store';
import { setUserRoleAction } from './userRole.reducer';

export const setUserRole =
  (userRole: string): AppThunk =>
  (dispatch: AppDispatch) => {
    return dispatch(setUserRoleAction(userRole));
  };
